export default __webpack_public_path__ + "static/media/md-card-bg-cybersecurity.936cf6b5.png";